module.exports = __webpack_public_path__ + "img/sertif-anglomama.e307942c.jpg";